// Composition Root — único lugar que conoce las clases concretas
import { SupabaseTenantRepository } from '@/infrastructure/adapter/out/SupabaseTenantRepository'
import { SupabaseSiteRepository } from '@/infrastructure/adapter/out/SupabaseSiteRepository'
import { SupabasePageRepository } from '@/infrastructure/adapter/out/SupabasePageRepository'
import { SupabaseApiKeyRepository } from '@/infrastructure/adapter/out/SupabaseApiKeyRepository'
import { InMemoryDomainEventBus } from '@/infrastructure/adapter/out/InMemoryDomainEventBus'
import { SupabasePersistentDomainEventBus } from '@/infrastructure/adapter/out/SupabasePersistentDomainEventBus'
import { supabase } from '@/infrastructure/supabase/client'
import { CreateTenantService } from '@/application/service/CreateTenantService'
import { CreateSiteService } from '@/application/service/CreateSiteService'
import { CreatePageService } from '@/application/service/CreatePageService'
import { PublishPageService } from '@/application/service/PublishPageService'
import type { ICreateTenantPort } from '@/application/port/in/ICreateTenantPort'
import type { ICreateSitePort } from '@/application/port/in/ICreateSitePort'
import type { ICreatePagePort } from '@/application/port/in/ICreatePagePort'
import type { IPublishPagePort } from '@/application/port/in/IPublishPagePort'
import type { ITenantRepository } from '@/application/port/out/ITenantRepository'
import type { ISiteRepository } from '@/application/port/out/ISiteRepository'
import type { IPageRepository } from '@/application/port/out/IPageRepository'
import type { IApiKeyRepository } from '@/application/port/out/IApiKeyRepository'
import type { IDomainEventBus } from '@/application/port/out/IDomainEventBus'

// ── Driven adapters (secondary) ───────────────────────────────
export const tenantRepository: ITenantRepository = new SupabaseTenantRepository()
export const siteRepository: ISiteRepository     = new SupabaseSiteRepository()
export const pageRepository: IPageRepository     = new SupabasePageRepository()
export const apiKeyRepository: IApiKeyRepository = new SupabaseApiKeyRepository()

// ── Domain Event Bus ──────────────────────────────────────────
// VITE_DOMAIN_EVENTS_PERSIST=true  → persists every event to the `domain_events` table
// VITE_DOMAIN_EVENTS_PERSIST=false → in-memory only (console.debug, no DB write)
// Requires migrate-021 to be applied before enabling.
export const eventBus: IDomainEventBus =
  import.meta.env['VITE_DOMAIN_EVENTS_PERSIST'] === 'true'
    ? new SupabasePersistentDomainEventBus(supabase)
    : new InMemoryDomainEventBus()

// ── Application services (implement primary ports) ────────────
export const createTenantPort: ICreateTenantPort = new CreateTenantService(tenantRepository, eventBus)
export const createSitePort:   ICreateSitePort   = new CreateSiteService(tenantRepository, siteRepository, eventBus)
export const createPagePort:   ICreatePagePort   = new CreatePageService(tenantRepository, pageRepository, eventBus)
export const publishPagePort:  IPublishPagePort  = new PublishPageService(pageRepository, eventBus)
